import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m15.2 14.6-3.9-3.9c1-1.1 1.6-2.5 1.6-4.1 0-3.4-2.7-6.1-6.1-6.1S.7 3.2.7 6.6s2.7 6.1 6.1 6.1c1.4 0 2.7-.5 3.7-1.3l3.9 3.9c.2.2.5.2.7 0 .3-.2.3-.5.1-.7m-8.4-2.9c-2.8 0-5.1-2.3-5.1-5.1S4 1.5 6.8 1.5s5.1 2.3 5.1 5.1c-.1 2.8-2.3 5.1-5.1 5.1" />
  </svg>
);
const SvgMagnify = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="magnify" {...props} />;
export default SvgMagnify;
